import CardAuthor from 'components/BlogComponents/CardAuthor'
import PostContent from 'components/BlogComponents/PostsContent'
import SimiliarPost from 'components/BlogComponents/SimiliarPost'
import BreadCrumb from 'components/BreadCrumb'
import LoadingContainer from 'components/LoadingContainer'
import { IGetPostContent, IGetPostSimiliar } from 'dtos/Posts'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { getPostBySlug, getSimiliarPost } from 'usecases/posts'
import * as Styles from './styles'
import ContentNotFound from 'new-components/blogComponents/ContentNotFound/index'

interface PostContentParams {
  slug?: string
  category?: string
}

const suggestedPosts = [
  {
    title: 'Produtos tópicos são porta de entrada da cannabis para idosos',
    slug: 'saude-e-bem-estar/produtos-topicos-sao-entrada-para-idosos',
    image: 'https://strapi.cannect.life/uploads/2150830169_39d625a07a.jpg',
    description:
      'Com informações da Cannalize. Em países em que os produtos à base de cannabis são mais comuns, os tópicos estão cada vez mais em alta...'
  },
  {
    title: 'Higiene do sono: o que significa?',
    slug: 'saude-e-bem-estar/higiene-do-sono-o-que-significa',
    image: 'https://strapi.cannect.life/uploads/Higiene_do_sono_scaled_5841e7f7fa.jpeg',
    description:
      'Ter uma boa noite de sono é reparador e ajuda a garantir a boa funcionalidade do nosso organismo. Principalmente na fase do sono profundo, o corpo aproveita para relaxar a musculatura...'
  },
  {
    title: 'A cannabis pode reduzir o consumo de outros remédios?',
    slug: 'saude-e-bem-estar/cannabis-pode-reduzir-o-consumo-de-outros-remedios',
    image: 'https://strapi.cannect.life/uploads/289_d0e9f630c3.jpg',
    description:
      'Produtos à base de cannabis estão se mostrando eficientes para tratar uma série de doenças. Inclusive, as substâncias que derivam da planta são naturais, podendo ser bem aceitas por mais organismos...'
  },
  {
    title: 'Cannabis medicinal como alternativa para doenças periodontais?',
    slug: 'saude-e-bem-estar/cannabis-medicinal-doencas-periodontais',
    image: 'https://strapi.cannect.life/uploads/pexels_karolina_grabowska_6627534_bf5af889c6.jpg',
    description:
      'Em 25 de outubro é celebrado o dia do cirurgião-dentista, profissional que atua em diferentes frentes da Odontologia. Sabe-se que a saúde bucal é muito importante, visto que a boca é uma das entradas de diversos nutrientes e substâncias para dentro do organismo...'
  }
]

function SlugPost() {
  const [postContent, setPostContent] = useState<IGetPostContent>({} as IGetPostContent)
  const [similarPost, setSimilarPost] = useState<IGetPostSimiliar>({} as IGetPostSimiliar)
  const [loading, setLoading] = useState(false)

  const { slug, category }: PostContentParams = useParams()

  const loadPostContent = async () => {
    setLoading(true)
    try {
      const responseCategories = await getPostBySlug({ slug })
      setPostContent(responseCategories)
      setLoading(false)
    } catch (e) {
      console.log(e)
    }
  }

  const loadSimiliarPost = async () => {
    setLoading(true)
    try {
      const responseCategories = await getSimiliarPost({ category })
      setLoading(false)
      setSimilarPost(responseCategories)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    loadPostContent()
    loadSimiliarPost()
  }, [slug])

  return (
    <Styles.Container>
      {loading ? (
        <div className="loading">
          <LoadingContainer loading />
        </div>
      ) : postContent?.data ? (
        <>
          <BreadCrumb
            paths={[
              { label: 'Blog', link: `/blog` },
              { label: category || '', link: `/blog/${category}` }
            ]}
          />
          <PostContent postContent={postContent.data} />
          <CardAuthor posts={postContent.data} />

          {similarPost?.data && similarPost.data.length > 0 ? (
            <SimiliarPost posts={similarPost.data} />
          ) : (
            <ContentNotFound suggestedPosts={suggestedPosts} />
          )}
        </>
      ) : (
        <p>Post não encontrado.</p>
      )}
    </Styles.Container>
  )
}

export default SlugPost
